/** 更多 —— 次要功能入口（底部導覽嘅「更多」tab）*/
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import TopBar from '../components/TopBar';

export default function More({ onLogout }: { onLogout: () => void }) {
  const { t } = useTranslation();
  const items: { to: string; label: string }[] = [
    { to: '/evidence', label: t('more.evidence') },
    { to: '/income', label: t('home.income_cta') },
    { to: '/invoices', label: t('home.items_cta') },
    { to: '/bank', label: t('home.bank_cta') },
    { to: '/assets', label: t('home.assets_cta') },
    { to: '/budget', label: t('home.budget_cta') },
    { to: '/profit', label: t('home.profit_cta') },
    { to: '/periods', label: t('home.periods_cta') },
    { to: '/export', label: t('home.export_cta') },
    { to: '/settings', label: t('more.settings') },
  ];
  return (
    <main className="page">
      <TopBar title={t('more.heading')} />
      <ul className="menu">
        {items.map((it) => (
          <li key={it.to}><Link className="menu-item" to={it.to}>{it.label}</Link></li>
        ))}
      </ul>
      <button type="button" className="cta secondary" onClick={onLogout}>{t('auth.sign_out')}</button>
    </main>
  );
}
